module.exports = __webpack_public_path__ + "img/carouMockmin.fa25f08f.jpg";